import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";
import HubSpotForm from "components/HubspotForm";

export default function NewColumnWithForm({
  customClass = "",
  formId,
  hubSpotForm,
  locale,
  successPageUrl = `${
    locale == "us" ? "/us/submission-success" : "/submission-success"
  }`,
  global,
  heading,
  pathPrefix,

  button_link_1 = `${locale == "us" ? "/us/contact-us" : "/contact-us"}`,
  button_title_1 = "Get in Touch",

  button_link_2 = `${locale == "us" ? "/us/jobs" : "/jobs"}`,
  button_title_2 = "Looking for a Job",

  // button_link_3 = `${locale == "us" ? "mailto:impellamnamarketing@impellam.com" : "mailto:solutions@lorienglobal.com"}`,
  // button_title_3 = "Speak with a Sales Expert",

  button_link_4 = `${
    locale == "us" ? "/us/salary-survey-2024" : "/salary-survey-2024"
  }`,
  button_title_4 = "Download Latest Report",

  description,
}) {
  return (
    <>
      <div id="form" className={`${styles.root} ${customClass}`}>
        {/* <span className="overlayBg position-absolute">
                    <img src={"/site-assets/svg/branded-logo.svg"} alt="Branded Logo" />
                </span> */}
        <Container>
          <hr className="pt-5" />
          <div className="d-flex gap-5 flex-wrap flex-lg-nowrap">
            <div className="column left">
              <h4 className="mb-4">
                <SourceFlowText global={global} path={`${pathPrefix}.heading`}>
                  {heading}
                </SourceFlowText>
              </h4>
              <div>
                <SourceFlowText
                  global={global}
                  path={`${pathPrefix}.description`}
                  type="html"
                >
                  {description}
                </SourceFlowText>
              </div>
              {/* {button_link_1 && (
                                <div>
                                    <a className="primaryBtn no-arrow" href={`${button_link_1}`}>
                                        {button_title_1}
                                    </a>
                                </div>
                            )}
                            {button_link_2 && (
                                <div>
                                    <a className="fourthBtn no-arrow" href={`${button_link_2}`}>
                                        {button_title_2}
                                    </a>
                                </div>
                            )}
                            {button_link_3 && (
                                <div>
                                    <a className="fourthBtn no-arrow" href={`${button_link_3}`}>
                                        {button_title_3}
                                    </a>
                                </div>
                            )}
                            {button_link_4 && (
                                <div>
                                    <a className="fourthBtn no-arrow" href={`${button_link_4}`}>
                                        {button_title_4}
                                    </a>
                                </div>
                            )} */}
            </div>
            <div className="column right">
              {hubSpotForm ? (
                <HubSpotForm form_id={hubSpotForm} />
              ) : formId ? (
                <SourceFlowForm
                  formId={formId}
                  onSubmitDone={() => (window.location.href = successPageUrl)}
                />
              ) : null}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}
